import { render, staticRenderFns } from "./ViewOrderAuthorCart.vue?vue&type=template&id=57cf6072&scoped=true&"
import script from "./ViewOrderAuthorCart.vue?vue&type=script&lang=js&"
export * from "./ViewOrderAuthorCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf6072",
  null
  
)

export default component.exports